export enum REMINDER_STATUS {
    ALL = 'All',
    PENDING = 'Pending',
    COMPLETED = 'Completed',
    OVERDUE = 'Overdue',
    DIMISSED = 'Dismissed',
    SNOOZED = 'Snoozed',
}

export enum REMINDER_TYPE {
    TASK = 'TASK',
    TODO = 'TODO',
    MANUAL = 'MANUAL',
}

export enum REMINDER_OBJECT_TYPE {
    ITEM_DATA = 'ITEM_DATA',
}
